import { TimeUnit } from '@mews/enums';

export const getSecondaryTimeUnit = (timeUnit: TimeUnit) => {
    switch (timeUnit) {
        case TimeUnit.Month:
            return TimeUnit.Day;
        default:
            return undefined;
    }
};
